<div class="runner-pairing">
  <ol class="runner-pairing__steps">
    <li>{{ 'runnerPairing.step.download' | translate }}</li>
    <li>{{ 'runnerPairing.step.start' | translate }}</li>
    <li>{{ 'runnerPairing.step.enter' | translate }}</li>
  </ol>

  @if (packagesState() === 'failed') {
    <p
      class="runner-pairing__packages-hint runner-pairing__packages-hint--error"
      role="alert"
      data-testid="runner-packages-failed"
    >
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      {{ 'runnerPairing.packages.loadFailed' | translate }}
    </p>
  } @else if (packagesState() === 'loaded' && packages().length === 0) {
    <p class="runner-pairing__packages-hint" role="status" data-testid="runner-packages-none">
      <mat-icon aria-hidden="true">info_outline</mat-icon>
      {{ 'runnerPairing.packages.none' | translate }}
    </p>
  } @else if (packages().length > 0) {
    <div class="runner-pairing__downloads">
      @for (platform of packages(); track platform) {
        <button
          type="button"
          class="runner-pairing__download"
          [disabled]="downloading() !== null"
          (click)="download(platform)"
        >
          @if (downloading() === platform) {
            <mat-progress-spinner mode="indeterminate" diameter="16" />
          } @else {
            <mat-icon aria-hidden="true">download</mat-icon>
          }
          {{ 'runnerPairing.platform.' + platform | translate }}
        </button>
      }
    </div>
  }

  <form class="runner-pairing__form" (ngSubmit)="submit()">
    <label class="runner-pairing__label" for="runner-pairing-code">
      {{ 'runnerPairing.codeLabel' | translate }}
    </label>
    <div class="runner-pairing__row">
      <input
        id="runner-pairing-code"
        class="runner-pairing__input"
        type="text"
        inputmode="numeric"
        autocomplete="off"
        maxlength="9"
        [placeholder]="'runnerPairing.codePlaceholder' | translate"
        [ngModel]="code()"
        (ngModelChange)="code.set($event)"
        name="userCode"
      />
      <button type="submit" class="runner-pairing__submit" [disabled]="!canSubmit()">
        @if (busy()) {
          <mat-progress-spinner mode="indeterminate" diameter="18" />
        }
        {{ 'runnerPairing.connect' | translate }}
      </button>
    </div>
  </form>

  @if (connectedRunner(); as runnerName) {
    <p class="runner-pairing__result runner-pairing__result--ok" role="status">
      <mat-icon aria-hidden="true">check_circle</mat-icon>
      {{ 'runnerPairing.connected' | translate: { name: runnerName } }}
    </p>
  }

  @if (error(); as messageKey) {
    <p class="runner-pairing__result runner-pairing__result--error" role="alert">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      {{ messageKey | translate }}
    </p>
  }

  @if (myRunners().length > 0) {
    <div class="runner-pairing__connected">
      <h3 class="runner-pairing__connected-title">{{ 'runnerPairing.connectedRunners.mine' | translate }}</h3>
      <app-runner-list [runners]="myRunners()" (changed)="myRunners.set($event)" />
      <a class="runner-pairing__show-all" routerLink="/runners" data-testid="runners-show-all-link">
        {{ 'runnerPairing.connectedRunners.showAll' | translate }}
      </a>
    </div>
  }

  <p class="runner-pairing__hint">{{ 'runnerPairing.hint' | translate }}</p>
</div>
